import React from 'react';
import { useNavigate } from 'react-router-dom';
import SocialFooter from '../components/SocialFooter';
import { ArrowLeft, ShieldCheck, Lock, Trash } from '@phosphor-icons/react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cardio-journey-app/artifacts/tyj7q2ct_logo%20365.png";

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background relative overflow-hidden" data-testid="privacy-screen">
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{ backgroundImage: `url(${LOGO_URL})`, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: '50%' }} />

      <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-xl border-b border-border px-6 py-4">
        <div className="max-w-2xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button onClick={() => navigate(-1)} className="w-10 h-10 rounded-full bg-card flex items-center justify-center" data-testid="back-btn">
              <ArrowLeft weight="bold" className="w-5 h-5 text-foreground" />
            </button>
            <img src={LOGO_URL} alt="Track365" className="w-40 h-auto" />
            <h1 className="text-xl font-bold text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>Privacy Policy</h1>
          </div>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-6 py-8 relative z-10">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-[#D4AF37]/10 flex items-center justify-center mx-auto mb-4">
            <ShieldCheck weight="duotone" className="w-8 h-8 text-[#D4AF37]" />
          </div>
          <h2 className="text-3xl font-bold text-foreground mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>Your Privacy Matters</h2>
          <p className="text-muted-foreground">Track365 Cardio respects your privacy.</p>
        </div>

        <div className="space-y-6">
          <div className="premium-card p-6">
            <h3 className="text-sm text-[#D4AF37] uppercase tracking-wider font-semibold mb-4">Information We Collect</h3>
            <p className="text-muted-foreground">We collect basic information such as your name, email, and fitness data to provide and improve our services.</p>
          </div>

          <div className="premium-card p-6">
            <h3 className="text-sm text-[#D4AF37] uppercase tracking-wider font-semibold mb-4">Your Data Is</h3>
            <div className="space-y-4">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-xl bg-green-500/10 flex items-center justify-center flex-shrink-0"><ShieldCheck weight="fill" className="w-5 h-5 text-green-500" /></div>
                <p className="text-foreground">Never sold to third parties</p>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-xl bg-green-500/10 flex items-center justify-center flex-shrink-0"><Lock weight="fill" className="w-5 h-5 text-green-500" /></div>
                <p className="text-foreground">Stored securely</p>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-xl bg-green-500/10 flex items-center justify-center flex-shrink-0"><Trash weight="fill" className="w-5 h-5 text-green-500" /></div>
                <p className="text-foreground">Used only to enhance your experience</p>
              </div>
            </div>
          </div>

          <div className="premium-card p-6">
            <h3 className="text-sm text-[#D4AF37] uppercase tracking-wider font-semibold mb-4">Data Deletion</h3>
            <p className="text-muted-foreground">
              You may request deletion of your account and data at any time by contacting{' '}
              <a href="mailto:support@track365cardio.com" className="text-[#D4AF37] hover:underline">support@track365cardio.com</a>
            </p>
          </div>

          <div className="text-center py-6 border-t border-border">
            <p className="text-muted-foreground text-sm">By using Track365 Cardio, you agree to this policy.</p>
            <p className="text-xs text-muted-foreground mt-2">Last updated: March 2026</p>
          </div>

          <SocialFooter />
        </div>
      </main>
    </div>
  );
};

export default Privacy;
